import { SessionKey_FE } from '@nu-art/user-account-frontend';
export const SessionKeyFE_OrganizationPermission = new SessionKey_FE('organization');
//# sourceMappingURL=consts.js.map